module.exports = __webpack_public_path__ + "img/12.5fc6e298.jpg";